<script lang="ts">
	import { Button, ListingStatus } from '@cf/ui-lib';
	import { TotalRemoveIcon, Review, Violance } from '@cf/ui-lib/icons';
	import Removed from '../../../uilib/overview/components/column/Removed.svelte';

	export let count;
	export let clickListing;
</script>

<div
	class="mb-10 grid
	  grid-cols-1 rounded-md
	  border border-solid border-border
	  bg-white p-5 shadow-[0px_2px_4px_0px_rgba(0,0,0,0.08)] md:grid-cols-2
	  xl:grid-cols-2"
>
	<div class="border-r border-solid border-border pr-[30px]">
		<div class="group container" on:click={() => {
							clickListing(ListingStatus.REMOVED);
						}}>
			<!-- <Button> -->
			<div class="inner-container flex items-end justify-between">
				<div class="followers-text my-2">
					<span
						class="text-sm font-medium group-hover:text-primary"
					>Total Removed</span
					>
				</div>
				<div class="icon-container bg-green-200 px-3 py-2">
					<TotalRemoveIcon />
				</div>
			</div>
			<h1
				class="text-title-md justify-start text-4xl font-bold text-black group-hover:text-primary "
			>
				{count?.REMOVED_count ? count?.REMOVED_count : 0}
			</h1>
			<!-- </Button> -->

			<div class="mt-4 flex items-end justify-start">
				<span class="text-meta-3 flex items-center gap-4 text-sm font-medium"
					>Since {count?.created_at ? count?.created_at : ''}
				</span>
			</div>
		</div>
	</div>
	<div class="pr-0">
		<div class="group container pl-[30px]" on:click={() => {
							clickListing(ListingStatus.NEEDS_REVIEW);
						}}>
			<div class="inner-container flex items-end justify-between">
				<div class="followers-text my-2">
					<span
						class="text-sm font-medium group-hover:text-primary"
						>Needs Review</span
					>
				</div>
				<div class="icon-container bg-amber-200 px-3 py-2">
					<Review />
				</div>
			</div>
			<h1
				class="text-title-md justify-start text-4xl font-bold text-black group-hover:text-primary "
			>
				{count?.NEEDS_REVIEW_count ? count?.NEEDS_REVIEW_count : 0}
			</h1>

			<div class="mt-4 flex items-end justify-start">
				<span class="text-meta-3 flex items-center gap-4 text-sm font-medium"
					>Since {count?.created_at ? count?.created_at : ''}
				</span>
			</div>
		</div>
	</div>
</div>
